import { dao } from '@platform/dao';
import type { IRecordViews } from '@platform/core/types';
import { baseApi, run } from '@platform/state/api';
import type { IAddRecordViewArg } from './IAddRecordViewArg';
import type { IRecordViewsArg } from './IRecordViewsArg';

/** Тег лічильників переглядів типу (окремий від статистики списку: зміни записів його не скидають). */
const viewsTag = (rt: string) => ({ type: 'Stats' as const, id: `views:${rt}` });

/**
 * Перегляди записів (V010, база знань прототипу v4): лічильники типу (GET …/records/{rt}/views — лише записи з переглядами, найпопулярніші
 * першими) і відкриття статті з бібліотеки (POST /records/{id}/views, +1), після якого лічильники типу перечитуються.
 */
export const recordViewsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    recordViews: b.query<IRecordViews[], IRecordViewsArg>({
      queryFn: ({ ws, rt }) => run(() => dao.records.views(ws, rt)),
      providesTags: (_r, _e, { rt }) => [viewsTag(rt)],
    }),
    addRecordView: b.mutation<IRecordViews, IAddRecordViewArg>({
      queryFn: ({ id }) => run(() => dao.records.addView(id)),
      invalidatesTags: (_r, _e, { rt }) => [viewsTag(rt)],
    }),
  }),
});

export const { useRecordViewsQuery, useAddRecordViewMutation } = recordViewsApi;
